import { render, staticRenderFns } from "./tabFixtureStats.vue?vue&type=template&id=20c01e17&"
import script from "./tabFixtureStats.vue?vue&type=script&lang=js&"
export * from "./tabFixtureStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports